export default __webpack_public_path__ + "static/media/1.fa29fb7d.png";